import { useBreakpoints } from '@assets/scripts/composables/useBreakpoints.js'

document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('sticky-header')
  if (!header) return

  const FIXED_CLASS = 'header_fixed'
  const VISIBLE_CLASS = 'is-visible'
  const DARK_BG_CLASS = 'bg-dark'

  const breakpoints = useBreakpoints()
  const tabletSm = breakpoints.get('tablet-sm')

  const heroSection = document.querySelector('.section.hero')
  const hasBgDarkInitially = header.classList.contains('bg-dark')

  const drawer = document.getElementById('drawer')
  const drawerHasBgDark = drawer && drawer.classList.contains('bg-dark')

  let isFixed = false

  let metaThemeColor = document.querySelector('meta[name="theme-color"]')
  if (!metaThemeColor) {
    metaThemeColor = document.createElement('meta')
    metaThemeColor.name = 'theme-color'
    document.head.appendChild(metaThemeColor)
  }

  function getCSSVariable(variableName) {
    return getComputedStyle(document.documentElement)
      .getPropertyValue(variableName)
      .trim()
  }

  function updateThemeColor(useDarkBg) {
    const color = useDarkBg
      ? getCSSVariable('--kova-color-background-dark')
      : getCSSVariable('--kova-color-background')

    if (color) {
      metaThemeColor.content = color
    }
  }

  function handleScroll() {
    const scrollY = window.scrollY

    let threshold = header.offsetHeight

    if (heroSection) {
      threshold = heroSection.offsetHeight
    }

    if (scrollY > threshold && !isFixed) {
      header.classList.add(FIXED_CLASS)

      if (hasBgDarkInitially) {
        header.classList.remove(DARK_BG_CLASS)
        // Убираем bg-dark у drawer только на экранах >= 768px
        if (drawer && drawerHasBgDark && window.innerWidth >= tabletSm) {
          drawer.classList.remove(DARK_BG_CLASS)
        }
        updateThemeColor(false) // Переключаем на светлый фон
      }

      setTimeout(() => {
        header.style.transition = 'transform 0.5s ease'
        header.classList.add(VISIBLE_CLASS)
      }, 100)

      isFixed = true
    } else if (scrollY <= threshold && isFixed) {
      header.classList.remove(VISIBLE_CLASS)

      setTimeout(() => {
        header.classList.remove(FIXED_CLASS)

        header.style.transition = 'none'

        if (hasBgDarkInitially) {
          header.classList.add(DARK_BG_CLASS)
          // Возвращаем bg-dark у drawer только на экранах >= 768px
          if (drawer && drawerHasBgDark && window.innerWidth >= tabletSm) {
            drawer.classList.add(DARK_BG_CLASS)
          }
          updateThemeColor(true) // Возвращаем тёмный фон
        }
      }, 300)

      isFixed = false
    }
  }

  window.addEventListener('scroll', handleScroll)

  handleScroll()
})